import React, {useState} from 'react';
import {Modal, Row, Spin} from "antd";
import '../modals.css';
import i18n from '../../../i18n';

export default function ModalShowRefuseReason({isShow, setIsShow, text, title = i18n.t('modals.modalShowRefuseReason.title')}) {

  const [loading, setLoading] = useState(false);

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  return (
    <Modal
      title={<span className="ant-modal-title">{title}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={null}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{text}</h2>
        </Row>
      </Spin>
    </Modal>
  );
}
